module.exports = __webpack_public_path__ + "static/media/non_existent.8d192819.jpg";